import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS } from "./translations";

const LangContext = createContext(null);
const KEY = "hammer_lang";

const detect = () => {
  try {
    const q = new URLSearchParams(window.location.search).get("lang");
    if (q && TRANSLATIONS[q]) return q;
    const s = localStorage.getItem(KEY);
    if (s && TRANSLATIONS[s]) return s;
  } catch {
    /* ignore */
  }
  return "it";
};

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(detect);

  const setLang = useCallback((l) => {
    if (!TRANSLATIONS[l]) return;
    setLangState(l);
    try {
      localStorage.setItem(KEY, l);
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = TRANSLATIONS[lang].meta.title;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: TRANSLATIONS[lang] }), [lang, setLang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
